export default __webpack_public_path__ + "static/media/fire.77f104e2.svg";